import {
  State,
} from '@/store/modules/system-messages/types';

export const state: State = {
  list: [],
};
